const withRenderedMain = require('components-framework/view/with_rendered_main');
const BaseView = require('components-framework/view/base.view');

module.exports = withRenderedMain(BaseView.extend({
    events: {
        'tap .download_app_link': 'onDownloadAppLinkClick',
    },

    onDownloadAppLinkClick(e) {
        const element = $(e.currentTarget);
        const action = 'app_download';
        const tag = element.data('trackingTag');
        Odigeo.trigger(`${this.id}:track`, {action, tag});
    },

}));
